import axios from "axios";
import React, { useState } from "react";
import { useQuery } from "react-query";
import BirthdayFeed from "../../../components/sections/BirthdayFeed";
import AttendanceAppreciationBanner from "../../../components/cards/AttendanceAppreciationBanner";
import ClassAnnouncementFeed from "../../../components/sections/ClassAnnouncementFeed";
import FeedSection from "../../../components/sections/FeedSection";
import StudentMainProfile from "../../../components/sections/StudentMainProfile";
import StudentsAchieve from "../../../components/sections/StudentsAchieve";
import { serverUrl } from "../../../nestserver";

const Index = () => {
  const [activeTab, setActiveTab] = useState("school-post");

  async function getAnnouncement() {
    const data = await axios({
      method: "get",
      url: serverUrl + "/announcement",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return data.data;
  }

  const announcement = useQuery("announcement", getAnnouncement);

  async function getUnreadCount() {
    const data = await axios({
      method: "get",
      url: serverUrl + "/personal-messages/unread-count",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return data.data;
  }

  const unreadCount = useQuery("unread-count", getUnreadCount);

  return (
    <div className="h-full px-10 py-8">
      <StudentMainProfile />
      <AttendanceAppreciationBanner />
      <div className="pt-10">
        <StudentsAchieve />
      </div>
      <div className="py-10">
        <div className="bg-white w-full rounded-2xl bg-opacity-40 px-4 pb-4">
          <div className="flex items-center gap-8 p-4 py-6">
            <div
              onClick={() => setActiveTab("school-post")}
              className="text-2xl font-semibold cursor-pointer pb-1"
              style={{
                color: activeTab === "school-post" ? "#E46E31" : "#9ca3af",
                borderBottom:
                  activeTab === "school-post"
                    ? "3px solid #E46E31"
                    : "3px solid transparent",
              }}
            >
              School Post
            </div>
            <div
              onClick={() => setActiveTab("class-announcement")}
              className="text-2xl font-semibold cursor-pointer pb-1 flex items-center gap-2"
              style={{
                color:
                  activeTab === "class-announcement" ? "#E46E31" : "#9ca3af",
                borderBottom:
                  activeTab === "class-announcement"
                    ? "3px solid #E46E31"
                    : "3px solid transparent",
              }}
            >
              Class Update
              {unreadCount?.data?.result > 0 && (
                <span className="bg-red-500 text-white rounded-full px-2 py-0.5 text-xs font-bold">
                  {unreadCount?.data?.result}
                </span>
              )}
            </div>
            <div
              onClick={() => setActiveTab("birthday")}
              className="text-2xl font-semibold cursor-pointer pb-1"
              style={{
                color: activeTab === "birthday" ? "#E46E31" : "#9ca3af",
                borderBottom:
                  activeTab === "birthday"
                    ? "3px solid #E46E31"
                    : "3px solid transparent",
              }}
            >
              🎂 Birthday
            </div>
          </div>

          {activeTab === "school-post" ? (
            <div className="space-y-5">
              {announcement?.isSuccess &&
                announcement?.data
                  ?.slice()
                  ?.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
                  )
                  ?.map((item, index) => {
                    return <FeedSection key={item?._id} data={item} />;
                  })}
            </div>
          ) : activeTab === "class-announcement" ? (
            <ClassAnnouncementFeed />
          ) : (
            <BirthdayFeed />
          )}
        </div>
      </div>
    </div>
  );
};

export default Index;
